import { INICIOU_REQUISICAO_WEB, FINALIZOU_REQUISICAO_WEB } from './actionTypes'

export const iniciouRequisicaoWeb = () => ({ type: INICIOU_REQUISICAO_WEB })
export const finalizouRequisicaoWeb = () => ({ type: FINALIZOU_REQUISICAO_WEB })